var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-float-ball",style:(_vm.ballStyle),on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag,"click":_vm.toggleLanguage}},[_c('div',{staticClass:"ball-content"},[_vm._v("\n        "+_vm._s(_vm.currentLanguage === 'zh' ? '中' : 'EN')+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }